<template>
  <section>
    <b-modal 
    title="Warning"
    ref="confirmNoPhone"
    hide-footer="true"
    size="lg" centered
    no-close-on-esc
    no-close-on-backdrop
    >
      <b-row class="p-3">
        <div class="mb-3">
          Security risk since no cell phone number exists for this user. 
        </div>
        <div>
          Do you want to go back and add a cell phone number (STRONGLY RECOMMENDED) for this user before generating a new passcode?
        </div>

      </b-row>
      <b-row >
        <b-col>
          <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="hideConfirmNoPhone">
          Yes, Go back to add cell phone
                  <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
          </b-btn>
  
        </b-col>
        <b-col>
          <b-btn variant="secondary" block class="text-nowrap cancel-btn-cmodal" @click="generatePasscode(true)">
                  No,  Proceed with generating new Passcode
          </b-btn>
  
        </b-col>

      </b-row>
    </b-modal>
    <c-modal
            ref="editUser"
            confirmLabel="Delete User"
            cancelLabel="Close"
            centered size="md"
            title="Edit User"
            :tag="tag"
            :icon="icon"
            :iconClass="iconClass"
            :label="label"
            :tagAttrs="tagAttrs"
            :progressing="progressing"
            @submit="deleteUser"
            @show="show"
            no-close-on-esc
            no-close-on-backdrop
    >
      <template>
        <div>
          <b-form-group>
            <b-input-group :prepend="'First Name'">
              <b-input
                      class="myFeild"
                      :name="'First Name'"
                      v-validate="'required'"
                      placeholder="Required"
                      v-model="model.FirstName"/>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="'Last Name'">
              <b-input
                      class="myFeild"
                      :name="'Last Name'"
                      v-validate="'required'"
                      placeholder="Required"
                      v-model="model.LastName"/>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="'Cell Phone'">
              <b-input-group-append>
            <b-input-group-text class="bg-white" :class="'border-left-0'">
                +1
            </b-input-group-text>
        </b-input-group-append>
              <b-input
                      v-model="model.Phone"
                      class="myFeild"
                      :name="'Cell Phone Number'"
                      v-mask="'###-###-####'"
                      placeholder="Optional"
              />
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-input-group :prepend="'Email'">
              <b-input
                      disabled
                      class="myFeild"
                      :name="'Email'"
                      v-validate="'required|email'"
                      placeholder="Required"
                      v-model="model.Email"/>
            </b-input-group>
          </b-form-group>

          <b-form-group class="mb-0">
            <b-input-group :prepend="'Role'">
              <b-form-select
              :disabled="isOwner() || !canChangeUserRole()"
                      :name="'Role'"
                      v-validate="'required'"
                      :options="roles"
                      value-field="ClientTypeID"
                      text-field="ClientType"
                      v-model="model.ClientTypeID"/>
            </b-input-group>
          </b-form-group>

          <!--                <b-form-group class="mb-0">-->
          <!--                    <b-input-group :prepend="'Role'">-->
          <!--                        <b-input-->
          <!--                            class="myFeild"-->
          <!--                            :name="'Email'"-->
          <!--                            placeholder="Required"-->
          <!--                            v-model="model.Role"/>-->
          <!--                    </b-input-group>-->
          <!--                </b-form-group>-->
        </div>
      </template>

      <div class="passcode" @click="toggleHidePIN()">
        <hr>
        <div>
          Passcode
        </div>
        
      </div>
      
      
      <template #actions="{hide}">
        
        <b-row v-if="!hidePinSection" class="flex-grow-1 flex-column justify-content-center align-items-center" >
          
          <div class="pin-gen-success-messsage">
          {{PinMessage}}
          </div>
          
          
          <b-row>
              
            <b-btn v-if="!disablePinBtn" variant="warning"  class="text-nowrap mb-5"
              style="margin-left:2rem" :disabled="progressing" @click="generatePasscode()">
              Generate New Passcode
              <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
            </b-btn>
            <b-btn v-else variant="secondary"  class="text-nowrap mb-5"
              style="margin-left:2rem" :disabled="true" @click="generatePasscode()">
              Generate New Passcode
              <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
            </b-btn>
          </b-row>
          

        </b-row> 
        <b-row class="flex-grow-1" >
          <b-col cols="4">
            <b-btn variant="warning" block class="text-nowrap" :disabled="progressing" @click="edit(hide)">
              Save Changes
              <font-awesome-icon v-if="progressing" spin icon="circle-notch" class="text-black align-middle mx-1"/>
            </b-btn>
          </b-col>
          <b-col cols="4">
            <b-btn variant="danger" block class="text-nowrap" :disabled="progressing" @click="deleteUser(hide)">
              Delete User
            </b-btn>
          </b-col>
          <b-col cols="4">
            <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="close(hide)">
              Cancel
            </b-btn>
          </b-col>
        </b-row>
      </template>
    </c-modal>
    <c-modal :tag="false" v-model="confirmModal" hide-footer hide-header centered>
      <template>
        <div class="text-center py-5">
          <p class="mb-3">
            User was successfully deleted.
          </p>
          <b-btn @click="confirmModal = false">
            Got it!
          </b-btn>
        </div>
      </template>
    </c-modal>
  </section>
</template>

<script>
  import CModal from "@/components/shared/Cmodal";
  export default {
    name: "attentionRemoveItems",
    components: {CModal},
    props: {
      value: {type: Object, required: true},
      tag: {type: [String, null]},
      icon: {type: String},
      iconClass: {type: String},
      label: {type: String, required: false, default: ''}
    },
    data () {
      return {
        progressing: false,
        tagAttrs: {
          variant: 'danger',
          size: 'sm'
        },
        roles: [],
        confirmModal: false,
        model: {
          FirstName: '',
          LastName: '',
          Phone: '',
          Email: '',
          ClientTypeID: ''
        },
        hidePinSection:true,
        PinMessage:"",
        disablePinBtn:false,
        
      }
    },
    methods: {
      showConfirmNoPhone() {
        this.$refs['confirmNoPhone'].show()
      },
      hideConfirmNoPhone() {
        this.$refs['confirmNoPhone'].hide()
      },
      show () {
        this.value.ClientTypeID = this.value.RoleID
        this.model = this.value
        this.getRoles()
      },
      isOwner() {
        return this.model.RoleID == 6
      },
      canChangeUserRole() {
        const currentRole = Number(localStorage.getItem('ClientTypeID'))
        if (currentRole === 6 || currentRole === 7) {
          return true
        }
        const role = this.roles.find(r => Number(r.ClientTypeID) === currentRole)
        const name = role && String(role.ClientType)
        return name === 'Business Owner' || name === 'Business Manager'
      },
      getRoles () {
        const filter = {
          // UserID: localStorage.getItem('userID'),
          RestaurantID: this.$store.state.selectedRestaurantId
        }
        return this.$api.getRestaurant.GetDashboardClientRole(filter, true).then(res => {
          this.progressing = false
          if (res.success) {
            this.roles = res.roles
            return res.roles
          }
        }).catch(() => {

        })
      },
      deleteUser (hide) {
        this.$showConfirm('', 'Are you sure delete this user?').then(() => {
          const model = {
            // UserID: localStorage.getItem('userID'),
            RestaurantID: this.$store.state.selectedRestaurantId,
            ClientID: this.value.ClientID
          }
          this.progressing = true
          return this.$api.getRestaurant.DeleteRestaurantUser(model).then(res => {
            this.progressing = false
            if (res.success) {
              this.$emit('refresh')
              // this.$showSuccess('User was successfully deleted.')
              hide()
              this.hidePinSection = true
              this.confirmModal = true
            } else {
              this.$showError(res.message)
            }
          })
        })
      },
      edit (hide) {
        
        
        
        
        let model = this.model
        model.RestaurantID = this.$store.state.selectedRestaurantId;
        model.TableIKey = 1;
        model.Phone = model.Phone.replace(/-/g, '')
        
        
        
        model.Phone = model.Phone.replace(' ', '')
        if(model.Phone != '')
        model.Phone = "+1"+model.Phone
        
        
        this.progressing = true
        return this.$api.getRestaurant.UpdateRestaurantUser(model).then(res => {
          this.progressing = false
          if (res.success) {
            this.$emit('refresh')
            this.hidePinSection = true
            this.close(hide)
          } else {
            this.$showError(res.message)
          }
        })
      },
      generatePasscode(skipCheck = false){

        if(this.model.Phone === "" && !skipCheck){
          return this.showConfirmNoPhone()
        }
        this.hideConfirmNoPhone()
        const model = {
          RestaurantID: this.$store.state.selectedRestaurantId,
          UserId:this.model.ClientID
        }
        this.progressing = true
        this.$api.user.GeneratePINforClientsInRestaurant(model).then(() => {
          
          this.progressing = false
          this.PinMessage = "New passcode generated and sent to this user via Email and text."
          this.disablePinBtn = true
          this.$emit('refresh')
        
        }).catch(()=>{
          this.$showError("Error occured while generating new pin")
          this.progressing =false;
        })
        
      },
      close(hide){
        this.hidePinSection = true
        this.PinMessage = ""
        this.disablePinBtn = false
        hide()
      },
      toggleHidePIN(){
        this.hidePinSection = !this.hidePinSection
      }
      
    },
  }
</script>

<style scoped>
  .passcode{
    margin-top: 2rem;
    position: relative;
    
  }
  .pin-gen-success-messsage{
    color:red;
    margin:0 0 1.5rem 1rem

  }
  .passcode>div{
    position: absolute;
    left: 42%;
    top: -0.75rem;
    font-size: larger;
    color:blue;
    background-color: white;
    cursor: pointer;
    padding: 4px;
  }
</style>
